export default __webpack_public_path__ + "static/media/barclay.4bfea916.svg";